import React, { useEffect, useState } from "react";
import { useGetAllRequestedQuery } from "../../store/api/orderProductApi";
import DataTable from "react-data-table-component";
import Logo from "../tools/Logo";
import { FaDownLong } from "react-icons/fa6";
import PDFRecievedPurchaseOrderGenerator from "../tools/PDFRecievedPurchaseOrderGenerator";
import AllPurchaseExcel from "../tools/AllPurchaseExcel";

const ExtendCard = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [genId, setGenId] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // --

  const [open, setOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const [orderedProduct, setOrderedProduct] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);

  const {
    data: ordered,
    error,
    isLoading,
  } = useGetAllRequestedQuery({
    refetchOnMountOrArgChange: false,
  });

  useEffect(() => {
    if (ordered) {
      setOrderedProduct(ordered);
    }
  }, [ordered]);

  useEffect(() => {
    const filterData = () => {
      let filtered = orderedProduct;

      // Filter by date range
      if (startDate && endDate) {
        filtered = filtered.filter(
          (item) => item[0]?.created >= startDate && item[0]?.created <= endDate
        );
      }

      // Filter by genId
      if (genId) {
        filtered = filtered.filter((item) =>
          item[0]?.genId.toLowerCase().includes(genId.toLowerCase())
        );
      }

      setFilteredData(filtered);
    };
    filterData();
  }, [startDate, endDate, genId, orderedProduct]);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div className="color-text fs-4">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div className="row">
          <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
            <h3 className="text-danger">Opps!!!</h3>
            <span className="fs-4">
              <span className="text-danger"> An Error has occurred</span>
            </span>
            <div className="fs-5"> The server is shut down 😢</div>
          </div>
        </div>
      </div>
    );
  }

  const showData = (index) => {
    setOpenIndex(index);
    setOpen(!open);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    const totalPages = Math.ceil(orderedProduct.length / newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page

    // If the current page is greater than the new total pages, set current page to the last page
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  };

  const _columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.requestedQty,
      sortable: true,
      center: true,
    },
    {
      name: "Received",
      selector: (row) => row.recievedQty,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.isArrived,
      cell: (row) => (
        <span className="text-center fw-bold text-success text-capitalize">
          {row.isArrived}
        </span>
      ),
      sortable: true,
      center: false,
    },
    {
      name: "Amount",
      selector: (row) => `$${(+row.amount || 0).toFixed(2)}`,
      sortable: true,
      center: true,
    },
    {
      name: "Updated At",
      selector: (row) => row.updated,
      sortable: true,
      center: true,
    },
    {
      name: "Create At",
      selector: (row) => row.created,
      sortable: true,
      center: true,
    },
  ];

  // Function to calculate the total amount
  // const calculateTotalAmount = (data) => data.reduce((sum, row) => sum + row.amount, 0);

  // Footer component to display total amount

  // const footerComponent = (data) => (
  //     <div style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold' }}>
  //        {data.reduce((sum, row) => sum + row.amount, 0)}
  //     </div>
  // );

  const getRequestDate = (date) => {
    const [year, month, day] = date.split("-").map(Number);
    const dt = new Date(year, month - 1, day);
    return dt.toDateString();
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleGenIdChange = (e) => {
    setGenId(e.target.value);
  };

  return (
    <>
      <div className="block-content block-content-full">
        <h2 className="content-heading text-uppercase">
          Recieved Purchased Orders
        </h2>
      </div>
      <div className="block1">
        <div className="block-content block-content-full">
          <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
            <div className="flex-grow-1">
              <label htmlFor="startDate" className="form-label">
                Start Date
              </label>
              <input
                style={{ height: "45px" }}
                type="date"
                className="form-control"
                id="startDate"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </div>

            <div className="flex-grow-1">
              <label htmlFor="endDate" className="form-label">
                End Date
              </label>
              <input
                style={{ height: "45px" }}
                type="date"
                className="form-control"
                id="endDate"
                value={endDate}
                onChange={handleEndDateChange}
              />
            </div>
            <div className="flex-grow-1">
              <button
                style={{
                  background: "#1a2131",
                  height: "45px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
                className="btn btn-success border-0 text-white"
                onClick={() =>
                  AllPurchaseExcel(filteredData, true, startDate, endDate)
                }
              >
                <FaDownLong /> Excel
              </button>
            </div>
            <div className="flex-grow-1">
              <label htmlFor="genId" className="form-label">
                Invoice ID
              </label>
              <input
                style={{ height: "45px" }}
                type="text"
                className="form-control"
                id="genId"
                value={genId}
                onChange={handleGenIdChange}
              />
            </div>
          </div>

          <div
            className="row text-white p-2 pb-0 border-0 mx-1 mb-0 mt-2"
            style={{ backgroundColor: "#01574E" }}
          >
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className="mx-xl-5">Invoice Id</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className="mx-xl-5">Supplier</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className="mx-xl-5">Category</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className="text-center mx-3">Date</h6>
            </div>
          </div>
          <div>
            {currentItems.map((list, index) => {
              return (
                <>
                  <div className="card mt-3">
                    <div className="card-header ">
                      <div class="row">
                        <div class="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12">
                          <div className="d-flex justify-content-start">
                            <button
                              className="btn btn-link bg-"
                              onClick={(e) => showData(index)}
                              aria-controls="example-collapse-text"
                              aria-expanded={open}
                            >
                              {open && index === openIndex ? (
                                <span>&#9660;</span>
                              ) : (
                                <span>&#9650;</span>
                              )}
                            </button>
                            <h6 className="mt-3">{list[0]?.genId}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12 ">
                          <h6 className="mt-3  mx-3"> {list[0]?.supplier}</h6>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12">
                          <h6 className="mt-3  mx-3"> {list[0]?.category}</h6>
                        </div>

                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12">
                          <h6 className="mt-3 text-xl-end  mx-3">
                            {" "}
                            {getRequestDate(list[0]?.created)}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {open && index === openIndex && (
                      <div id="example-collapse-text" className="collapse show">
                        <div className="card-body">
                          {/* <DataTable
                                                        columns={_columns}
                                                        data={list}
                                                    /> */}

                          <div
                            className="table-responsive position-relative"
                            style={{ overflowX: "auto" }}
                          >
                            <table
                              class="table mb-5 "
                              style={{ minWidth: "1000px" }}
                            >
                              <thead className="table-secondary">
                                <tr>
                                  <th scope="col">Name</th>
                                  <th scope="col">Requested Quantity</th>
                                  <th scope="col">Recieved Quantity</th>
                                  <th scope="col">Unit</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Amount</th>
                                  <th scope="col">Total</th>
                                  <th scope="col">Create At</th>
                                  <th scope="col">Updated At</th>
                                  <th scope="col">
                                    <button
                                      title="Download"
                                      className="btn bg-success border-0"
                                      onClick={() =>
                                        PDFRecievedPurchaseOrderGenerator(list)
                                      }
                                    >
                                      <Logo
                                        _width={25}
                                        name={
                                          "../../../image/icons/download.svg"
                                        }
                                        _color={"#01574E"}
                                        _height={20}
                                        _marginLeft={0}
                                      />
                                    </button>
                                    <button
                                      style={{
                                        background: "#1a2131",
                                        marginLeft: "20px",
                                      }}
                                      className="btn btn-success me-2 border-0  text-white  pl-20 pr-20"
                                      onClick={() =>
                                        AllPurchaseExcel(
                                          list,
                                          false,
                                          startDate,
                                          endDate
                                        )
                                      }
                                    >
                                      <FaDownLong /> Excel
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {list.map((data, dataIndex) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{data.name}</td>
                                        <td>{data.requestedQty}</td>
                                        <td>{data.recievedQty}</td>
                                        <td>{data.unit}</td>
                                        <td>
                                          <span className="text-center fw-bold text-success text-capitalize">
                                            {data.isArrived}
                                          </span>
                                        </td>
                                        <td>{`$${(+data.amount || 0).toFixed(2)}`}</td>
                                        <td>{`$${Math.round((data.total || 0) * 100) / 100}`}</td>
                                        <td>{data.created}</td>
                                        <td colSpan="2">{data.updated}</td>
                                      </tr>
                                    </>
                                  );
                                })}
                                <tr>
                                  <td colSpan="6" className="text-right">
                                    <strong>Total</strong>
                                  </td>
                                  <td>
                                    <strong>{`$${list
                                      .reduce(
                                        (sum, item) => sum + item.total,
                                        0
                                      )
                                      .toFixed(2)}`}</strong>
                                  </td>
                                  <td colSpan="3"></td>{" "}
                                  {/* Adding empty cells to align with columns */}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            })}
          </div>

          <div className="mt-4">
            <ul className="pagination justify-content-end">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              <li className="page-item disabled">
                <span className="page-link">{currentPage}</span>
              </li>
              <li
                className={`page-item ${
                  currentItems.length < itemsPerPage ? "disabled" : ""
                } ${
                  currentItems.length === orderedProduct.length
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
              <li className="page-item mx-2">
                <select
                  className="form-select p-0 px-5 py-1 rounded-0"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value="3">3</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExtendCard;
